<template>
    <div class="form-row w100">
        <h5 style="display: inline-block">Перечень услуг для B2C</h5>
        <button type="button" class="btn btn-primary text-right ml-2 mb-2" size="sm" @click="openModal()">
            <b-icon icon="plus" font-scale="1.2"></b-icon>
        </button>

        <!-- Динамические таблицы -->
        <div 
            v-for="(group, group_index) in groupedServices" 
            :key="`group_${group_index}`" 
            class="mt-4"
            style="width: 100%; overflow-x: auto;"
        >
            <!-- <h5>Таблица: {{ group.name }}</h5> -->

            <b-table-simple small bordered responsive :caption-top="false">
                <colgroup>
                    <col 
                        v-for="col in group.columns" 
                        :class="styleTdByColKey(col.key)"
                        :key="`col_${col.key}`"
                    ></col><col class="td-actions"></col>
                </colgroup>
                <b-thead>
                    <b-tr>
                        <b-th 
                            v-for="col in group.columns" 
                            :class="[styleTdByColKey(col.key), 'align-top']"
                            :key="`head_${col.key}`"
                        >
                            {{ col.name }}
                        </b-th>
                        <b-th class="td-actions text-center table-b-table-default b-table-sticky-column">Действие</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr 
                        v-for="services_idx in group.services"
                        :key="`service_${services_idx}_${services_idx}`"
                    >
                        <b-td 
                            v-for="col in group.columns" 
                            :class="[styleTdByColKey(col.key), 'align-top']"
                            :key="`col_${col.key}`"
                        >
                            <template v-if="col.type === 'Формула'">
                                <div class="text-value-td-div">
                                    {{ servicesList[services_idx][col.key] || 'NaN' }}
                                </div>
                            </template>
                            <template v-else-if="col.type === 'Число'">
                                <b-form-input
                                    v-model="servicesList[services_idx][col.key]"
                                    type="number"
                                    step="0.01"
                                    title="Введите значение"
                                    placeholder="Введите значение"
                                    style="min-width: 90px;"
                                    size="sm"
                                    :key="`input_${services_idx}_${services_idx}_${col.key}`"
                                    :id="`input_${services_idx}_${services_idx}_${col.key}`"
                                ></b-form-input>
                            </template>
                            <template v-else-if="col.type === 'Дата'">
                                <b-form-input
                                    v-model="servicesList[services_idx][col.key]"
                                    :key="`input_${services_idx}_${services_idx}_${col.key}`"
                                    :id="`input_${services_idx}_${services_idx}_${col.key}`"
                                    type="date"
                                    style="min-width: 100px;"
                                    size="sm"
                                ></b-form-input>
                            </template>
                            <template v-else-if="col.type === 'Строка'">
                                <b-form-textarea
                                    v-model="servicesList[services_idx][col.key]"
                                    :key="`input_${services_idx}_${services_idx}_${col.key}`"
                                    :id="`input_${services_idx}_${services_idx}_${col.key}`"
                                    type="text"
                                    style="min-width: 200px;"
                                    size="sm"
                                    trim
                                    rows="4"
                                    class="textarea-value"
                                ></b-form-textarea>
                            </template>

                            <template v-else>
                                <div class="text-value-td-div">
                                    {{ servicesList[services_idx][col.key] || '-' }}
                                </div>
                            </template>
                        </b-td>
                        <b-td class="td-actions text-center align-top table-b-table-default b-table-sticky-column">
                            <b-button-group size="sm">
                                <b-button
                                    variant="table"
                                    @click="removeService(services_idx)"
                                    style="max-width: 50px;"
                                >
                                    <i class="fas fa-trash text-danger"></i>
                                </b-button>
                            </b-button-group>
                        </b-td>    
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>        

        <b-modal 
            v-model="showModal" 
            title="Добавление услуг в счет" 
            size="lg" 
            centered
        >
            <b-form>
                <b-form-group label="Добавить шаблон">
                    <b-list-group>
                        <template v-if="templates.length == 0">
                            <em>Не создано ни одного шаблона. Создайте шаблоны в конструкторе услуг.</em>
                        </template>
                        <b-list-group-item 
                            v-for="(template, t_index) in templates" 
                            :key="`template_${template.id}`"
                        >
                            <div class="d-flex w-100 justify-content-between">
                                <div style="line-height: 16px;">{{ template.name }}
                                    <ul style="list-style: disc; margin-left: 15px; margin-bottom: 0; margin-top: 10px;">
                                        <li 
                                            v-for="(service, index) in template.services" 
                                            :key="`li_service_${service.id}`"
                                        >
                                            <div class="d-flex w-100 justify-content-between">
                                                <div style="line-height: 16px;">{{ service.name }}
                                                    <div class="text-muted small" v-if="service.columns && formatServiceColumns(service.columns).length > 0">
                                                        (<span 
                                                            v-for="(column, colIndex) in formatServiceColumns(service.columns)"
                                                            :key="colIndex"
                                                        >{{ column.name }} -> {{ column.default }}{{ colIndex < formatServiceColumns(service.columns).length - 1 ? '; ' : '' }}</span>)
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                                <div>
                                    <b-button 
                                        :variant="addTemplateButtons.includes(t_index) ? 'success':'secondary'" 
                                        @click="addTemplate(template, t_index)"
                                    >
                                        <template v-if="addTemplateButtons.includes(t_index)">
                                            Добавлено!
                                        </template>
                                        <template v-else>
                                            Добавить
                                        </template>
                                    </b-button>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-form-group>
                <b-form-group label="Добавить услуги">
                    <b-list-group>
                        <template v-if="services.length == 0">
                            <em>Не создано ни одной услуги. Создайте услуги в конструкторе услуг.</em>
                        </template>
                        <b-list-group-item 
                            v-for="(service, s_index) in services" 
                            :key="`service_${service.id}`"
                        >
                            <div class="d-flex w-100 justify-content-between">
                                <div style="line-height: 16px;">{{ service.name }}
                                    <div class="text-muted small" v-if="service.columns && formatServiceColumns(service.columns).length > 0">
                                        (<span 
                                            v-for="(column, colIndex) in formatServiceColumns(service.columns)"
                                            :key="colIndex"
                                        >{{ column.name }} -> {{ column.default }}{{ colIndex < formatServiceColumns(service.columns).length - 1 ? '; ' : '' }}</span>)
                                    </div>
                                </div>
                                <div>
                                    <b-button 
                                        :variant="addServiceButtons.includes(s_index) ? 'success':'secondary'" 
                                        @click="addService(service, s_index)"
                                    >
                                        <template v-if="addServiceButtons.includes(s_index)">
                                            Добавлено!
                                        </template>
                                        <template v-else>
                                            Добавить
                                        </template>
                                    </b-button>
                                </div>
                            </div>
                        </b-list-group-item>
                    </b-list-group>
                </b-form-group>
            </b-form>

            <template #modal-footer>
                <b-button 
                    variant="secondary" 
                    @click="showModal = false"
                >Закрыть</b-button>
                <!-- <b-button 
                    variant="primary" 
                    @click="addServices"
                >Сохранить</b-button> -->
            </template>
        </b-modal>
    </div>
</template>

<script>
import { API_COMPANY_FINANCE_TEMPLATES, API_COMPANY_FINANCE_SERVICES } from '@/constants';

import {
    changeCommasOnDots
} from '@/mixins';

export default {
    name: 'B2CServicesList',
    props: {
        companyId: {
            type: Number | String,
            required: true
        },
        servicesList: Array,
        editedItem: Object
    },
    mixins: [
        changeCommasOnDots,
    ],
    data() {
      return {
        loading: false,
        templates: [],
        services: [],
        showModal: false,
        groupedServices: [],
        selectedServices: [],
        addServiceButtons: [],
        addTemplateButtons: []
      };
    },
    watch: {
        servicesList: {
            deep: true,
            immediate: true,
            handler() {
                this.formServiceGroups();
                this.calculateAllFormulas();
                this.calculateTotal();
            },
        },         
    },
    mounted() {
        this.fetchTemplates();
        this.fetchServices();
    },
    methods: {
        fetchTemplates() {
            this.loading = true;
            api.call("get", `${API_COMPANY_FINANCE_TEMPLATES}?company_id=${this.companyId}`)
                .then(response => {
                    this.templates = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        fetchServices() {
            api.call("get", `${API_COMPANY_FINANCE_SERVICES}?company_id=${this.companyId}`)
                .then(response => {
                    this.services = response.data;
                });
        },
        openModal() {
            this.showModal = true
        },
        formServiceGroups() {
            const groups = [];

            this.servicesList.forEach((service, s_index) => {
                const groupKey = service.columns.map((col) => col.key).sort().join('_');
                let group = groups.find((g) => g.key === groupKey);
                if (!group) {
                    group = {
                        key: groupKey,
                        name: `Группа ${groups.length + 1}`,
                        columns: service.columns.map((col) => ({
                            key: col.key,
                            name: col.name,
                            type: col.type
                        })),                        
                        services: [],
                    };

                    groups.push(group);
                }

                group.services.push(s_index);
            });

            this.groupedServices = groups;
        },
        addTemplate(template, index) {
            template.services.forEach((service) => {
                this.addService(service);
            });

            this.addTemplateButtons.push(index);

            setTimeout(() => {
                this.addTemplateButtons.shift();
            }, 1500);
        },        
        addService(service, index = -1) {
            // Построение объекта на основе columns
            const newService = service.columns.reduce((acc, column) => {
                let value = column.default !== null ? column.default : '';

                if (column.type === "Формула") {
                    value = 0;
                }

                acc[column.key] = value;
                
                return acc;
            }, {});

            // Добавление дополнительных данных, если требуется
            newService.id = this.servicesList.length + 1;
            newService.name = service.name || '';
            newService.sum = newService.sum || 0;
            newService.columns = service.columns;

            // Вызов addOneService с новым объектом
            this.addOneService(newService);

            if (index !== -1) {
                this.addServiceButtons.push(index);

                setTimeout(() => {
                    this.addServiceButtons.shift();
                }, 1500);
            }
        },
        addOneService(data = {}) {
            this.$emit('addService', data, true);
            this.$emit('recalculate');
        },
        // addOneService(data = {}) {
        //     this.$emit('addService', {
        //         id: this.servicesList.length + 1,
        //         name: (data.name ? data.name : ''),
        //         number: (data.number ? data.number : 1),
        //         sum: (data.sum ? data.sum : 0),
        //     });

        //     this.$emit('recalculate');
        // },
        removeService(index) {
            this.$emit('removeService', index);
            this.$emit('recalculate');
        },
        formatServiceColumns(columns) {
            return Object.values(columns)
                .filter(column => !['id', 'name', 'sum'].includes(column.key)) // Exclude specific keys
                .slice(0, 3) // Take only the first three columns
                .map(column => ({
                    name: column.name,
                    default: column.default || "—",
                }));
        },
        calculateTotal() {
            this.$emit('recalculate');
        },
        /**
         * Пересчитывает значения формул на основе текущих данных.
         */
         calculateAllFormulas() {
            if (!this.servicesList || !Array.isArray(this.servicesList)) {
                console.error("servicesList is not defined or not an array");
                return;
            }

            // Проходим по каждой строке (услуге)
            this.servicesList.forEach((service, serviceIndex) => {
                if (!service || !Array.isArray(service.columns)) {
                    console.error(`Invalid service structure at index ${serviceIndex}`);
                    return;
                }

                const dependencies = {};
                const calculatedValues = { ...service }; // Начальные значения из текущей строки

                // Собрать зависимости и формулы для текущей строки
                service.columns.forEach((column) => {
                    if (!column || typeof column !== "object") {
                        console.error(`Invalid column structure in service at index ${serviceIndex}`);
                        return;
                    }

                    if (column.type === "Формула") {
                        const formula = column.default ? column.default.replace(/;/g, ",") : "";
                        const references = formula.match(/COL_\d+/g) || [];
                        dependencies[column.key] = { formula, references };
                    } else {
                        calculatedValues[column.key] = service[column.key];
                    }
                });

                // Выполнить топологическую сортировку для текущей строки
                let sortedKeys = [];
                try {
                    sortedKeys = this.topologicalSort(dependencies);
                } catch (error) {
                    console.error(`Topological sort failed for service at index ${serviceIndex}: `, error.message);
                    return;
                }

                // Вычислить значения для текущей строки
                sortedKeys.forEach((key) => {
                    const dependency = dependencies[key];
                    if (!dependency) {
                        console.error(`Dependency for key ${key} not found in service at index ${serviceIndex}`);
                        return;
                    }

                    const { formula, references } = dependency;

                    try {
                        let parsedFormula = formula.replace(/COL_\d+/g, (match) => {
                            const value = calculatedValues[match];
                            if (value !== undefined) {
                                return value;
                            }
                            throw new Error(`Value for ${match} is missing in service at index ${serviceIndex}`);
                        });

                        parsedFormula = parsedFormula.replace(/ЕСЛИ\(([^,]+),([^,]+),([^)]+)\)/g, '($1 ? $2 : $3)');

                        calculatedValues[key] = this.safeEvaluate(parsedFormula.replace("=", ""));
                    } catch (error) {
                        console.error(`Error in formula for key ${key} in service at index ${serviceIndex}: ${error.message}`);
                        calculatedValues[key] = "NaN";
                    }
                });

                // Обновить значения формул в текущей строке
                service.columns.forEach((column) => {
                    if (column.type === "Формула") {
                        service[column.key] = (typeof calculatedValues[column.key] === 'number') ? calculatedValues[column.key].toFixed(2).replace(',', '.') : calculatedValues[column.key];
                    }
                });
            });
        },
        /**
         * Выполняет безопасное вычисление формулы.
         */
        safeEvaluate(expression) {
            return Function(`"use strict"; return (${expression})`)();
        },
        /**
         * Топологическая сортировка для порядка вычислений.
         */
        topologicalSort(dependencies) {
            const visited = new Set();
            const sorted = [];
            const visit = (key) => {
                if (!visited.has(key)) {
                    visited.add(key);
                    (dependencies[key] && dependencies[key].references ? dependencies[key].references : []).forEach(visit);
                    sorted.push(key);
                }
            };
            Object.keys(dependencies).forEach(visit);
            return sorted;
        },        
        styleTdByColKey(key) {
            switch (key) {
                case 'id':
                    return 'td-id';
                case 'name':
                    return 'td-name';
                case 'sum':
                    return 'td-sum';
                default:
                    return '';
            }
        }
    },
};
</script>

<style scoped>
    .textarea-value {
        line-height: 16px;
    }
    .td-id {
        width: 3%;
        max-width: 40px;
        min-width: 40px;
        text-align: center;
    }
    .td-name {
        width: 250px;
    }
    .td-sum {
        width: 10%;
        min-width: 150px;
    }
    .td-actions {
        width: 6%;
        min-width: 90px;
        max-width: 90px;
        text-align: center !important;
        vertical-align: top;
    }
    .text-value-td-div {
        padding-top: 8px;
    }
</style>